<template>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <v-avatar color="grey" size="32">
            <span v-if="getUser.image==='noimage'" class="white--text headline">
              {{getUser.first_name[0].toUpperCase() + getUser.last_name[0].toUpperCase()}}
            </span>
            <v-img v-if="getUser.image!=='noimage'" height="100%" :src="getUser.image">
            </v-img>
          </v-avatar>
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <!-- if in project -->
        <template v-if="$route.matched[0] && $route.matched[0].name === 'Project'">
          <v-list-item @click="navigateProject('TAKT.plan')">
            <v-list-item-action>
              <v-icon>calendar_today</v-icon>
            </v-list-item-action>
            <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Project.TaktPlan.Label')}}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateProject('TAKT.wallet')">
            <v-list-item-action>
              <svg-icon
                class="mr-1"
                name="takt_wallet"
                :size="25"
              />
            </v-list-item-action>
            <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Project.TaktWallet.Label')}}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateProject('TAKT.journal')">
            <v-list-item-action>
              <v-icon>description</v-icon>
            </v-list-item-action>
            <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Project.TaktJournal.Label')}}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="navigateProject('PROJECT.settings')">
            <v-list-item-action>
              <v-icon>settings_applications</v-icon>
            </v-list-item-action>
            <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Project.ProjectSettings.Label')}}</v-list-item-title>
          </v-list-item>
        </template>

        <!-- generell -->


        <v-list-item :to="{name: 'ProjectOverView'}">
          <v-list-item-action>
            <v-icon>domain</v-icon>
          </v-list-item-action>
          <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Projects')}}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'WorkBench'}">
          <v-list-item-action>
            <svg-icon
              class="mr-1"
              name="takt_workbench"
              :size="25"
            />
          </v-list-item-action>
          <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Workbench')}}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('Stats READ')" :to="{name: 'Dashboard'}">
          <v-list-item-action>
            <v-icon>dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Dashboard')}}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPermission('AI TAKTING')" :to="{name: 'AIDashboard'}">
          <v-list-item-action>
            <v-icon>extension</v-icon>
          </v-list-item-action>
          <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Ai')}}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item :to="{name: 'Account'}">
          <v-list-item-action>
            <v-icon>account_box</v-icon>
          </v-list-item-action>
          <v-list-item-title style="margin-left: -25px">{{$t('AppLayout.NavBar.Account')}}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-action>
            <v-icon>power_settings_new</v-icon>
          </v-list-item-action>
          <v-list-item-title style="margin-left: -25px">{{$t('Buttons.Logout')}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
</template>
<script>
import {
  mapGetters
} from 'vuex';
export default {
  data: () => ({
    lightTheme: false
  }),
  watch: {
    lightTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  },
  computed: {
    ...mapGetters('Auth', [
      'getUser',
      'hasPermission'
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex'
    ])
  },
  methods: {
    logout() {
      this.$store.dispatch('Auth/logout', {});
    },
    navigateProject(title){
      let to = 'ProjectTaktPlan';
      let project_id = this.$route.params.project_id;
      let params = {
        project_id: project_id
      }
      switch (title) {
        case 'TAKT.plan':
          to = 'ProjectTaktPlan';
          break;
        case 'TAKT.wallet':
          to = 'ProjectWalletTakt';
          params.takt_index = this.getCurrentTaktIndex(project_id) !== false?
                              Math.abs(this.getCurrentTaktIndex(project_id)):1
          break;
        case 'TAKT.journal':
          to = 'ProjectTaktPlan';
          break;
        case 'PROJECT.settings':
          to = 'ProjectSettings';
          break;
      }
      this.$router.push({
        name: to,
        params: params
      });
    }
  },
}
</script>
